import ScenarioOverviewTable from "./scenarioOverviewTable";
import { CircularProgress } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DataTable2 from "examples/Tables/DataTable2";

function LibraryScenarios() {
  const { t } = useTranslation();
  const navigate = useNavigate();
    const { tableData, loading, error } = ScenarioOverviewTable();
  
    if (loading) {
      return (
        <MDBox p={3}>
          <MDTypography variant="h6" fontWeight="medium" gutterBottom>
            <CircularProgress />
          </MDTypography>
        </MDBox>
      );
    }
  
    if (error) {
      return (
        <MDBox p={3}>
          <MDTypography variant="h6" color="error" gutterBottom>
            {t("scenarios.library.loadError")} {error}
          </MDTypography>
        </MDBox>
      );
    }
    return (
    <DashboardLayout>
      <div className="diagramContainer">
        <div className="scrollable-100">
          <DataTable2
            table={tableData}
            canSearch
            onRowClick={(row) => navigate(`/scenarioView/${row.id}`, { state: { scenario: row } })}
          />
        </div>
      </div>
          </DashboardLayout>
    );
  }

export default LibraryScenarios;
